var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "loginForm",
      attrs: { model: _vm.form, rules: _vm.rules },
      nativeOn: {
        keyup: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.onSubmit.apply(null, arguments)
        },
      },
    },
    [
      _vm.currentAward
        ? _c("p", { staticClass: "orangetext" }, [
            _vm._v(
              "\n        Log in your account in order to submit your project for " +
                _vm._s(_vm.currentAwardName) +
                ".\n        You can use the same account for all Global Design News awards submissions.\n    "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          staticClass: "form-group",
          attrs: { prop: "email", error: _vm.$t(_vm.formErrors.get("email")) },
        },
        [
          _c("el-input", {
            attrs: {
              name: "email",
              placeholder: _vm.$t("auth.login.email_label") + " *",
              type: "text",
            },
            model: {
              value: _vm.form.email,
              callback: function ($$v) {
                _vm.$set(_vm.form, "email", $$v)
              },
              expression: "form.email",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          staticClass: "form-group",
          attrs: {
            prop: "password",
            error: _vm.$t(_vm.formErrors.get("password")),
          },
        },
        [
          _c("el-input", {
            attrs: {
              name: "password",
              placeholder: _vm.$t("auth.login.password_label") + " *",
              type: "password",
              "show-password": "",
            },
            model: {
              value: _vm.form.password,
              callback: function ($$v) {
                _vm.$set(_vm.form, "password", $$v)
              },
              expression: "form.password",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { xs: 24, md: 12 } },
            [
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.form.remember_me,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "remember_me", $$v)
                    },
                    expression: "form.remember_me",
                  },
                },
                [_vm._v("Keep me signed in")]
              ),
              _c("BR"),
              _vm._v(" "),
              _vm.currentAward
                ? _c(
                    "router-link",
                    {
                      staticClass: "forgotLink",
                      attrs: { to: _vm.forgotLink },
                    },
                    [_vm._v("Forgot your password?")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "text-right", attrs: { xs: 24, md: 12 } },
            [
              _c(
                "el-button",
                {
                  staticClass: "loginButton",
                  attrs: { loading: _vm.loading },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.onSubmit.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("auth.login.submit_button")) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }